import { reducer } from './reducer';
import { sagas } from './sagas';


export * from './types';
export * from './actions';


export const news = {
    reducer,
    sagas,
};
